module.exports = __webpack_public_path__ + "img/infoSimple.03741f68.png";